<template>
  <div id="connectioncontainter">
    <p v-if="!isConnected && !isConnectionFailed">Bezig met verbinding maken...</p>
    <b-spinner class="p-2" variant="success" label="connecting" v-if="!isConnected && !isConnectionFailed"></b-spinner>
    <div id="connectionfailed" v-if="isConnectionFailed" class="alert alert-danger" role="alert">Kon geen verbinding maken met de server.<br />
      Ververs de pagina of probeer het later opnieuw.
    </div>

    <!-- Error view -->
    <div id="error" v-if="gameError" class="alert alert-danger" role="alert">
      {{ gameError }}
      <button @click.prevent="leaveGames()" type="submit" class="btn btn-primary mb-2">Klik hier om bestaande spellen te verwijderen</button>
    </div>
    <!-- Error view -->
    <div id="error" v-if="connectionError && !isConnected" class="alert alert-danger" role="alert">
      {{ connectionError }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ConnectionErrors',
  computed: {
    ...mapGetters({
      isConnected: 'quiz/connected',
      gameError: 'quiz/gameError',
      connectionError: 'quiz/connectionError',
      isConnectionFailed: 'quiz/connectionFailed'
    })
  },
  methods: {
    leaveGames: function () {
      this.$store.dispatch('quiz/leaveGame')
    }
  }
}
</script>
